"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtmCookieConsentServiceImpl = void 0;
const IS_BROWSER = typeof window !== "undefined";
class GtmCookieConsentServiceImpl {
    constructor() {
        if (IS_BROWSER) {
            this.initDataLayer();
        }
    }
    setConsent(consent, isDefaultConfig) {
        const gtmConsentConfigMapping = {
            ad_storage: this.getGtmConsentValue(consent.advertising),
            analytics_storage: this.getGtmConsentValue(consent.analytics),
            personalization_storage: this.getGtmConsentValue(consent.functionality),
            functionality_storage: this.getGtmConsentValue(consent.functionality),
            security_storage: this.getGtmConsentValue(consent.necessary),
        };
        this.sendToGTM(gtmConsentConfigMapping, isDefaultConfig);
    }
    setContainerId(containerId) {
        this.gtmContainerId = containerId;
    }
    sendToGTM(consent, isDefaultConfig) {
        if (IS_BROWSER && this.gtmContainerId) {
            // @ts-ignore
            this.gtag("consent", isDefaultConfig ? "default" : "update", consent);
            // @ts-ignore
            this.gtag("js", new Date());
            // @ts-ignore
            this.gtag("config", this.gtmContainerId);
            if (!isDefaultConfig) {
                window.dataLayer.push({
                    event: "cookies_consent_update",
                });
            }
        }
    }
    getGtmConsentValue(isActivated) {
        return isActivated ? "granted" : "denied";
    }
    initDataLayer() {
        window.dataLayer = window.dataLayer || [];
    }
    gtag() {
        window.dataLayer.push(arguments);
    }
}
exports.GtmCookieConsentServiceImpl = GtmCookieConsentServiceImpl;
//# sourceMappingURL=gtmCookieConsentServiceImpl.js.map